import axios from 'axios';
import { getBaseUrl } from "../../service/apiUrl";
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getCompetitionTimer = createSlice({
    name: 'CompetitionTimer',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },
 
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompetitionTimer.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchCompetitionTimer.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchCompetitionTimer.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    },
});

export const { setCompetitionTimer, setStatus } = getCompetitionTimer.actions;
export default getCompetitionTimer.reducer;

export const fetchCompetitionTimer = createAsyncThunk('competition-v2/timer/fetch', async () => {
    const res = await axios.get(`${getBaseUrl()}/competition-v2/timer`)
    const data =  res.data;
    return data.data;
});